import Swiper from "swiper/bundle";
import Form from "../modules/form";

const SingleProduct = {
  init() {
    Form.init();

    SingleProduct.slider();
    SingleProduct.scrollToForm();
  },

  slider() {
    let swiper_product = new Swiper(".product-slider", {
      slidesPerView: 1,
      navigation: {
        nextEl: ".arrow--right",
        prevEl: ".arrow--left",
      },
      pagination: {
        el: ".swiper-pagination",
      },
    });
  },

  scrollToForm() {
    //scroll to form
    $('a[href="#contact-form"]').on('click', function (e) {
      e.preventDefault();

      var top = $('.feedback-form-block').offset().top;

      $('body,html').animate({scrollTop: top - 150}, 1000);

    });
  },
};
export default SingleProduct;
